import { jsx as n } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { Divider as x } from "@mui/material";
function u(h) {
  const e = c(18);
  let i, r, l, t, s;
  e[0] !== h ? ({
    width: s,
    height: r,
    sx: t,
    children: i,
    ...l
  } = h, e[0] = h, e[1] = i, e[2] = r, e[3] = l, e[4] = t, e[5] = s) : (i = e[1], r = e[2], l = e[3], t = e[4], s = e[5]);
  let f;
  e[6] !== r || e[7] !== s ? (f = {
    width: s,
    height: r
  }, e[6] = r, e[7] = s, e[8] = f) : f = e[8];
  let o;
  e[9] !== t ? (o = Array.isArray(t) ? t : [t], e[9] = t, e[10] = o) : o = e[10];
  let m;
  e[11] !== f || e[12] !== o ? (m = [f, ...o], e[11] = f, e[12] = o, e[13] = m) : m = e[13];
  let d;
  return e[14] !== i || e[15] !== l || e[16] !== m ? (d = /* @__PURE__ */ n(x, { sx: m, ...l, children: i }), e[14] = i, e[15] = l, e[16] = m, e[17] = d) : d = e[17], d;
}
export {
  u as Divider
};
